"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearButton = exports.ChildrenContainer = exports.BulkEditDivider = exports.BulkEditText = exports.StyledBulkEdit = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.StyledBulkEdit = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: ", ";\n  height: 31px;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  margin: ", ";\n  height: 31px;\n  justify-content: space-between;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.BulkEditText = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.BulkEditDivider = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.ChildrenContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.ClearButton = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  padding: 0 ", ";\n"], ["\n  color: ", ";\n  padding: 0 ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.black;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.base;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
